import React from 'react';

function ThresholdEditor(props) {
  const { thresholds, onChangeThreshold, onAdd, onRemove } = props;

  return (
    <div>
      {thresholds.map((t, idx) => (
        <div key={idx} className="threshold-row">
          <select
            value={t.type || 'numeric'}
            onChange={(e) =>
              onChangeThreshold(idx, { type: e.target.value, matchValue: '', min: undefined, max: undefined })
            }
            style={{ fontSize: '11px', padding: '4px', marginBottom: '4px' }}
          >
            <option value="numeric">Numeric Range</option>
            <option value="string">String Match</option>
          </select>

          {t.type === 'string' ? (
            <input
              type="text"
              placeholder="Match value (e.g., 'active')"
              value={t.matchValue || ''}
              onChange={(e) =>
                onChangeThreshold(idx, { matchValue: e.target.value })
              }
              style={{ width: '100%', marginBottom: '4px' }}
            />
          ) : (
            <>
              <input
                type="number"
                placeholder="min"
                value={t.min !== undefined ? t.min : ''}
                onChange={(e) =>
                  onChangeThreshold(idx, {
                    min:
                      e.target.value === ''
                        ? undefined
                        : Number(e.target.value),
                  })
                }
              />
              <input
                type="number"
                placeholder="max"
                value={t.max !== undefined ? t.max : ''}
                onChange={(e) =>
                  onChangeThreshold(idx, {
                    max:
                      e.target.value === ''
                        ? undefined
                        : Number(e.target.value),
                  })
                }
              />
            </>
          )}

          <input
            type="color"
            value={t.color}
            onChange={(e) =>
              onChangeThreshold(idx, { color: e.target.value })
            }
          />
          <select
            value={t.animation || 'none'}
            onChange={(e) =>
              onChangeThreshold(idx, { animation: e.target.value })
            }
            style={{ fontSize: '11px', padding: '4px' }}
          >
            <option value="none">No Animation</option>
            <option value="pulse">Pulse</option>
            <option value="shake">Shake</option>
            <option value="flash">Flash</option>
          </select>
          <button
            className="danger"
            onClick={() => onRemove(idx)}
          >
            ✕
          </button>
        </div>
      ))}
      <button
        onClick={onAdd}
        style={{ marginTop: '0.5rem' }}
      >
        + Add Threshold
      </button>
    </div>
  );
}

export default ThresholdEditor;
